import React from 'react';
import Swal from 'sweetalert2';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ReactJson from 'react-json-view';
import { FaSun, FaSave, FaRev } from "react-icons/fa";
import { IoIosCloudyNight } from "react-icons/io";

//Scripts auxiliares:
import { registerAuditProcess } from '../../../tools/scripts/customFetching';

//Estilos base:
const actionButtonStyle = { padding: "3px 10px", backgroundColor: "transparent", color: "#65615c", marginLeft: 5 };

class SourceJsonUpdater extends React.Component {

    constructor() {
        super();

        this.state = {
            JsonHasChanged: false,
            targetJson: undefined,
            lastChangeRecord: undefined,
            theme: "shapeshifter:inverted",
            activeDownloadSourceId: undefined
        }
    }

    render() {
        return (
            <div style={{ overflowX: "hidden" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flex: "50%" }}>
                        {this.getSourceTitle(this.props)}
                    </div>

                    <div style={{ flex: "50%", textAlign: "right" }}>
                        {this.getThemeSelectorButton()}
                        {this.getSaveChangesButton()}
                        {this.reverseParametrizationDefaultButton()}
                    </div>
                </div>

                <div data-tut="reactour__sourcesConfiguration.JSONUpdater">
                    <ReactJson
                        style={{ borderRadius: 15, padding: 15 }}
                        src={this.state.targetJson} collapsed={3} displayDataTypes={true}
                        enableClipboard={false} collapseStringsAfterLength={30} theme={this.state.theme}
                        onEdit={(e) => { this.setState({ JsonHasChanged: true, lastChangeRecord: e }); }} />
                </div>
            </div>
        );
    }

    componentDidMount(){
        
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.activeDownloadSource && this.props.activeDownloadSource.id !== this.state.activeDownloadSourceId) {
            this.fetchParametrizationFromBacked();
        }
    }

    //Métodos operativos:
    fetchParametrizationFromBacked = () => {
        
        window.document.body.style.cursor = "wait";
        fetch(process.env.REACT_APP_API_URL + "/sources_parametrization/" + this.props.activeDownloadSource.id + "/", {
            method: 'GET',
            headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken }
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                        serverResponse.json()
                            .then(downloadSource => {
                                this.setState({
                                    activeDownloadSourceId: downloadSource.id,
                                    targetJson: downloadSource.parametrization,
                                });
                            })
                            .catch(error => { console.log(error); });
                        break;

                    default:
                        console.log("Error descargando los sources desde backend...");
                        break;
                }

                window.document.body.style.cursor = "default";
            })
            .catch(error => { console.log(error); window.document.body.style.cursor = "default"; });
    }

    fireErrorAlert = (source)=>{
        Swal.fire(
            source.description,
            'Los cambios <b>no se aplicaron</b> exitosamente',
            'error'
        );
    }

    fireSuccessAlert = (source) => {
        Swal.fire(
            source.description,
            'Los cambios fueron aplicados <b>correctamente</b>',
            'success'
        );
    }

    saveChangesOnBackend = () => {
        if (this.state.lastChangeRecord !== undefined) {
            fetch(process.env.REACT_APP_API_URL + "/sources_parametrization/" + this.props.activeDownloadSource.id + "/", {
                method: 'PUT',
                headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken, 'Content-Type': 'application/json' },
                body: JSON.stringify({ "parametrization": this.state.lastChangeRecord.updated_src })
            })
                .then(serverResponse => {
                    switch (serverResponse.status) {
                        case 200:

                            registerAuditProcess(this.props, {
                                "event_type":"JSON_CONFIG_UPDATED",
                                "description": this.getTranslatedChangeReport(this.state.lastChangeRecord)
                            });

                            this.setState({
                                JsonHasChanged: false,
                                lastChangeRecord: undefined
                            });

                            this.fireSuccessAlert(this.props.activeDownloadSource);
                            break;

                        default:
                            this.fireErrorAlert(this.props.activeDownloadSource);
                            break;
                    }

                    window.document.body.style.cursor = "default";
                })
                .catch(error => { console.log(error); window.document.body.style.cursor = "default"; });
        }
    }


    reverseJsonOnBackend = () => {
       
        fetch(process.env.REACT_APP_API_URL + "/sources/" + this.props.activeDownloadSource.id + "/reset_parametrization/", {
            method: 'POST',
            headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken, 'Content-Type': 'application/json' },
            body: JSON.stringify({ })
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 206:
                    case 200:
                        registerAuditProcess(this.props, {
                            "event_type":"JSON_REVERSE_DEFAULT",
                            "description": "El usuario reverso el json a su version original"
                        });
                        this.fireSuccessAlert(this.props.activeDownloadSource);
                        //this.setState({ JsonHasChanged: !this.state.JsonHasChanged});
                        this.fetchParametrizationFromBacked();
                        break;

                    default:
                        this.fireErrorAlert(this.props.activeDownloadSource);
                        break;
                }

                window.document.body.style.cursor = "default";
            })
            .catch(error => { console.log(error); window.document.body.style.cursor = "default"; });
       
    }

    //Métodos para renderizado:
    getSaveChangesButton = () => {
        if (this.state.JsonHasChanged) {
            return (
                <Button className="btn btn-default animated fadeInUp" title="Confirmar cambios"
                    style={{ ...actionButtonStyle }} onClick={this.saveChangesOnBackend}>
                    <FaSave />
                </Button>
            );
        }
    }

    reverseParametrizationDefaultButton = () => {
        
        return (
            <Button className="btn btn-default animated fadeInUp" 
                data-tut="reactour__sourcesConfiguration.JSONReverseDefaultButton"
                title="retornar json por defecto"
                style={{ ...actionButtonStyle }} onClick={this.reverseJsonOnBackend}>
                <FaRev />
            </Button>
        );
        
    }

    getSourceTitle = (props) => {
        if (props.activeDownloadSource && props.activeDownloadSource.description !== undefined) {
            let mainWord = props.activeDownloadSource.description.split(":")[0];
            let secondaryWord = props.activeDownloadSource.description.split(":")[1];
    
            let title = mainWord;
            if (secondaryWord) { title += ": <b>" + secondaryWord + "</b>" }
            else { title = "<b>" + title + "</b>"; }
    
            return (
                <React.Fragment>
                    <p style={{ fontSize: 11, marginBottom: 0, textTransform: "uppercase" }}
                        dangerouslySetInnerHTML={{ __html: title }} />
    
                    <p style={{ fontSize: 9, marginBottom: 0, textTransform: "uppercase" }}
                        dangerouslySetInnerHTML={{ __html: "Preconfiguración de parametrización" }} />
                </React.Fragment>
            );
        }
    }

    getThemeSelectorButton = () => {
        return (
            <Button className="btn btn-default" style={{ ...actionButtonStyle }}
                data-tut="reactour__sourcesConfiguration.JSONUpdaterLightModeButton"
                title={(this.state.theme.includes("shapeshifter")) ? "Cambiar a modo oscuro" : "Cambiar a modo claro"}
                onClick={() => {
                    let newTheme = !this.state.theme.includes("shapeshifter") ? "shapeshifter:inverted" : "tomorrow";
                    this.setState({ theme: newTheme });
                }}>
                {(this.state.theme.includes("shapeshifter")) ? <IoIosCloudyNight /> : <FaSun />}
            </Button>
        );
    }

    getTranslatedChangeReport = (changeRecord) => {
        let report = "El usuario <b>cambió el atributo de configuración</b> " + changeRecord.name;

        for (let i = changeRecord.namespace.length - 1; i >= 0; i--) {
            if (isNaN(parseFloat(changeRecord.namespace[i]))) {
                report += " del atributo " + changeRecord.namespace[i];
            }
            else {
                report += " del " + this.getTranslatedIndex(changeRecord.namespace[i]) + " de la lista";
            }
        }

        report += " de " + this.props.activeDownloadSource.description.replace(":", ": ") +
            ". Pasó de ser <b>" + changeRecord.existing_value + "</b> a <b>" + changeRecord.new_value + "</b>";
        return report;
    }

    getTranslatedIndex = (index) => {
        switch (index) {
            case "0":
            case 0:
                return "primer elemento";

            case "1":
            case 1:
                return "segundo elemento";

            case "2":
            case 2:
                return "tercero elemento";

            case "3":
            case 3:
                return "cuarto elemento";

            case "4":
            case 4:
                return "quinto elemento";

            default:
                return "elemento " + index;
        }
    }
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        coreBackendHost: state.mainReducer.coreBackendHost,
        enableAuditRegistering: state.mainReducer.enableAuditRegistering
    };
};

export default connect(mapStateToProps)(SourceJsonUpdater);